import WizardHeading from 'components/customComponents/Controls/WizardHeading';
import WizardParagraph from 'components/customComponents/Controls/WizardParagraph';
import React, { useContext, useEffect, useState } from 'react';
import { ReactComponent as PrintBarCodeIcon } from 'Icons/SceenExpWizard/PrintBarcode.svg';
import { ReactComponent as SaveSetupIcon } from 'Icons/SceenExpWizard/SaveSetup.svg';
import { ReactComponent as SaveSetupAsIcon } from 'Icons/SceenExpWizard/SaveSetupAs.svg';
import RMCard from 'components/customComponents/Controls/RMCard';
import ScreenWizardContext from './ScreenWizardContext';
import TemplateName from './TemplateName';
import WizardService from 'business/services/WizardService';
import {
  ExperimentDTO,
  LayerTypeDTO,
  PrintBarcodeApiResponse,
  ProteinFormulationDTO,
  ProteinLayerDTO,
  ScreenLayerDTO,
  ScreenLotDTO,
} from 'business/models/Models';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import ExperimentService from 'business/services/ExperimentService';
import {
  GetProteingFormulationList,
  isNullOrUndefined,
  launchExpPrintBarCodeRequest,
  showSnackBar,
} from 'utils/Global';
import { generate } from 'business/plateviewer/Generate/GenerateCommon';
import { useRockFetchPost } from 'utils/RockFetch';
import { initLayer } from 'components/plateviewer/experiment/PasteLayerHelper';
import { ProteinLayerProteinFormulationDetailsDTO } from 'business/models/CustomModels';
import { EGridVaryAlong } from 'enums/ELayersView';
import LoadingExps from './LoadingExps';
import SucccessMessage from 'components/customComponents/Controls/SucccessMessage';
import { getUniqueLayerName } from 'business/plateviewer/GenerateUtil';
import { TreeService } from 'business/services/TreeService';
import { CHANNEL_ACTIONS } from 'business/broadcast';
import { removeExperimentFromScreen } from 'utils/ExperimentUtils';
import { useShowLabelPrinterError } from 'CustomHooks';

const CreateExperiments = () => {
  const [contentBody, setContentBody] = useState(true);
  const [loading, setLoading] = useState(true);
  const [currExpNumber, setCurrExpNumber] = useState(0);
  const [experimentIds, setExperimentIds] = useState([]);
  const [disabledSaveSetup, setDisabledSaveSetup] = useState(false);
  const [isSetupSave, setIsSetupSave] = useState(false);
  const [saveSetupTitle, setSaveSetupTitle] = useState('');

  const [rockFetchPost] = useRockFetchPost();
  const screenWizContext = useContext(ScreenWizardContext);
  const totalExperiments = screenWizContext.experimentInfoList.length;
  const [isSaveAsDisabled, setIsSaveAsDisabled] = useState(false);
  const showLabelPrinterError = useShowLabelPrinterError();

  async function onClickBarCode() {
    const printResponses: PrintBarcodeApiResponse[] = await launchExpPrintBarCodeRequest(
      experimentIds,
    );
    if (printResponses?.some((r) => r.value != '')) {
      showLabelPrinterError();
    } else {
      const truncMsg = printResponses?.find((r) => r.infoMessage?.trim())?.infoMessage;
      if (truncMsg) {
        showSnackBar(truncMsg);
      }
    }
  }
  const wizardService: WizardService = new WizardService();
  const treeService: TreeService = new TreeService();
  function changeContentView(title) {
    title ? setSaveSetupTitle(title) : setSaveSetupTitle('Save Setup');
    setContentBody((val) => !val);
  }
  useEffect(() => {
    async function saveExperiment(expDto, expInfo, layers, parentTreenodeId) {
      return await wizardService.saveWizardExperiment(
        expDto,
        expInfo,
        parentTreenodeId,
        layers,
      );
    }

    async function createExps() {
      const expIds = [];
      for (let i = 0; i < totalExperiments; i++) {
        setCurrExpNumber(i + 1);
        const expInfo = screenWizContext.experimentInfoList[i];
        let expDtoClient: ExperimentDtoClient;
        const body = {
          experimentInfo: expInfo,
          paretnTreeNodeId: screenWizContext.expSaveLocation,
        };
        const response = await rockFetchPost(
          'api/screenexpwizard/createExperiment',
          body,
        );
        if (response == null) {
          setLoading(false);
          return;
        }
        if (response !== null) {
          expDtoClient = response;
        }
        const globalPFList: ProteinFormulationDTO[] = GetProteingFormulationList();
        const serv: ExperimentService = new ExperimentService();
        const screenLotDetails: ScreenLotDTO = await serv.getScreenLotDetails(
          expInfo.screenInfo.screenLotId,
        );
        expDtoClient.layers = [];
        const { newLayer: screenLayer, layerDetail: screenLayerDetails } = initLayer(
          -1,
          LayerTypeDTO.Screen,
          expDtoClient,
          0,
        );
        (screenLayerDetails as ScreenLayerDTO).screenLot = screenLotDetails;
        screenLayer.layerDetail = screenLayerDetails;
        screenLayer.volumeBasedAddition = false;

        screenWizContext.proteins.forEach((dropProtein, index) => {
          if (isNullOrUndefined(dropProtein)) {
            return;
          }
          if (isNullOrUndefined(dropProtein.name)) {
            return;
          }
          const { newLayer: proteinLayer, layerDetail: proteinLayerDetail } = initLayer(
            -1,
            LayerTypeDTO.Protein,
            expDtoClient,
            0,
          );
          const layerName = getUniqueLayerName(expDtoClient.layers, dropProtein.name);
          proteinLayer.name = layerName;
          const proteinFormulation = globalPFList.find(
            (pf) => pf.treeNodeId == dropProtein.id,
          );
          proteinLayer.volumeBasedAddition = true;
          proteinLayer.layerDetail = proteinLayerDetail;
          proteinLayer.targetDrop = index + 1; //dropProtein.dropNumber;
          const plDTO: ProteinLayerDTO = proteinLayerDetail;

          let plPFDTO: ProteinLayerProteinFormulationDetailsDTO;
          if (
            plDTO.proteinLayerProteinFormulation === undefined ||
            plDTO.proteinLayerProteinFormulation.length === 0
          ) {
            plPFDTO = new ProteinLayerProteinFormulationDetailsDTO();
            plDTO.proteinLayerProteinFormulation = [];
            plDTO.proteinLayerProteinFormulation.push(plPFDTO);
          } else {
            plPFDTO = plDTO.proteinLayerProteinFormulation[0];
          }

          plDTO.layerId = proteinLayer.id;
          plPFDTO.proteinFormulationId = proteinFormulation.id;
          plPFDTO.proteinDropVolumeVaryAlong = EGridVaryAlong.NONE;
          plPFDTO.startProteinDropVolume = dropProtein.dropVolume;
          plPFDTO.stopProteinDropVolume = dropProtein.dropVolume;
          plPFDTO.wellDropVolumeVaryAlong = EGridVaryAlong.NONE;
          plPFDTO.startWellDropVolume = dropProtein.proteinVolume;
          plPFDTO.stopWellDropVolume = dropProtein.proteinVolume;
          const pfdto = new ProteinFormulationDTO();
          pfdto.id = proteinFormulation.id;
          plPFDTO.proteinFormulation = pfdto;

          plPFDTO.proteinFormulationId = proteinFormulation.id;
          expDtoClient.layers.push(proteinLayer);
        });
        expDtoClient.layers.push(screenLayer);
        generate(expDtoClient, false);
        expDtoClient.layers = removeExperimentFromScreen(expDtoClient.layers);
        const expDto: ExperimentDTO = new ExperimentDTO();
        expDto.init(expDtoClient);
        const expId = await saveExperiment(
          expDto,
          screenWizContext.experimentInfoList[i],
          expDtoClient.layers,
          screenWizContext.expSaveLocation,
        );
        if (expId == null) {
          setLoading(false);
          return;
        }

        const treeNode = await treeService.getTreeNodeByExpId(expId);
        screenWizContext.explorerBroadcastChannel?.postMessage({
          action: CHANNEL_ACTIONS.EXPLORER_ADD_NODE,
          payload: treeNode,
        });

        expIds.push(expId);
      }
      setLoading(false);
      setExperimentIds(expIds);
    }
    createExps();
  }, []);

  function saveTemplateSetup() {
    if (screenWizContext.createNewExp) {
      changeContentView(null);
    } else {
      const isSetupSaveRes: boolean = screenWizContext.saveScreenExpTemplate(
        screenWizContext.expTemplate,
      );
      if (isSetupSaveRes != null) {
        setIsSetupSave(isSetupSaveRes);
      }
      setDisabledSaveSetup(true);
    }
  }

  return loading ? (
    <LoadingExps currExp={currExpNumber} totalExps={totalExperiments} />
  ) : (
    <div
      id="createexperiments-loading-wrapper"
      className="flex flex-column flex-y-center h-100"
    >
      <WizardHeading text="Congratulations!" style={{ marginTop: '20px' }} />
      <WizardParagraph text="The wizard has successfully created your experiments." />
      <WizardParagraph text="Your experiment can be found in the following folder:" />
      <WizardParagraph
        text={screenWizContext.createExpPath}
        customStyle={{ fontWeight: 'bold' }}
      />
      {contentBody ? (
        <div id="createexperiments-content-wrapper">
          <div
            id="createexperiments-card-container"
            className="flex-x-center"
            style={{ marginTop: '120px' }}
          >
            <RMCard
              Icon={<PrintBarCodeIcon id="createexp-card-printbarcode-icon" />}
              title="Print Barcode"
              onClick={onClickBarCode}
              disabled={false} // disabled because testing pending
            />
            <RMCard
              Icon={<SaveSetupIcon id="createexp-card-savesetup-icon" />}
              title="Save Setup"
              onClick={saveTemplateSetup}
              disabled={disabledSaveSetup || !screenWizContext.wizardDataDirty}
            />
            <RMCard
              Icon={<SaveSetupAsIcon id="createexp-card-savesetupas-icon" />}
              title="Save Setup As"
              onClick={() => changeContentView('Save Setup As')}
              disabled={isSaveAsDisabled}
            />
          </div>{' '}
          {isSetupSave && <SucccessMessage text="Your setup has been saved!" />}
        </div>
      ) : (
        <TemplateName
          id="createexperiments-templatename"
          changeContentView={changeContentView}
          setDisableSaveSetup={setDisabledSaveSetup}
          setIsSetupSave={setIsSetupSave}
          setSaveAsDisabled={setIsSaveAsDisabled}
          title={saveSetupTitle}
        />
      )}
    </div>
  );
};

export default CreateExperiments;
